export default __webpack_public_path__ + "static/media/train.fc47e104.png";